import React from 'react';
import PropTypes from 'prop-types';

import { useCompletedOrders } from '../../hooks';

import Order from '../Order';
import ColumnCarousel from '../ColumnCarousel';
import Loading from '../Loading';
import useGlobalContent from '../../hooks/use-global-content';

const OrdersList = ({ title }) => {
  const { general = {} } = useGlobalContent('error');
  const { data, loading, error } = useCompletedOrders();

  return (
    <section className="orders-list">
      <div className="container-guttered">
        <ColumnCarousel
          title={title}
          bypass>
          {loading && <Loading relative small dark/>}
          {error && general.default}
          {data !== null && data.map(order => (
            <Order
              key={`order_${order.number}`}
              {...order}
            />
          ))}
        </ColumnCarousel>
      </div>
    </section>
  );
};

OrdersList.propTypes = {
  title: PropTypes.string.isRequired,
  country: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default OrdersList;



// WEBPACK FOOTER //
// ./src/client/js/view/components/OrdersList/OrdersList.js